import { Link } from "react-router-dom";

const PRODUCT_LINKS = [
  ["Home", "/", "footer-link-home"],
  ["Stag Vault Complete", "/pricing", "footer-link-pricing"],
  ["Stag Vault Prompt Playbook · £19", "/playbook", "footer-link-playbook"],
  ["Store · single tracks", "/store", "footer-link-store"],
  ["Free prompt preview", "/library-preview", "footer-link-preview"],
  ["Find your track", "/quiz", "footer-link-quiz"],
  ["Fast services", "/collections/fast-monetisation-services", "footer-link-fast-monetisation"],
];

const RESOURCE_LINKS = [
  ["About", "/about", "footer-link-about"],
  ["Guides", "/guides", "footer-link-guides"],
  ["Roadmap", "/roadmap", "footer-link-roadmap"],
  ["The £1K Challenge", "/1k-challenge", "footer-link-1k-challenge"],
  ["Trades training tracks", "/collection/trades-training", "footer-link-trades-training"],
  ["Study resources", "/study", "footer-link-study"],
  ["TikTok offer", "/tiktok", "footer-link-tiktok"],
];

const TRUST_LINKS = [
  ["Founder", "/founder", "footer-link-founder"],
  ["Editorial method", "/editorial-method", "footer-link-editorial-method"],
  ["Author: Ross", "/authors/ross", "footer-link-author"],
  ["Review & corrections", "/review-and-corrections", "footer-link-corrections"],
  ["Results disclaimer", "/results-disclaimer", "footer-link-results-disclaimer"],
  ["Sample outputs", "/sample-outputs", "footer-link-sample-outputs"],
  ["Member stories", "/member-stories", "footer-link-member-stories"],
  ["Contact Stag Vault", "/contact", "footer-link-contact"],
];

PRODUCT_LINKS.push(["Earn With Stag Vault · Affiliate Program", "/affiliates", "footer-link-affiliates"]);

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-zinc-900 bg-[#030206] text-zinc-500" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 md:px-10 lg:py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-12">
          <div className="sm:col-span-2 lg:col-span-4">
            <Link to="/" className="inline-flex min-h-11 items-center" data-testid="footer-logo">
              <img src="/stag-vault-lockup-v2.webp" alt="Stag Vault" width="701" height="200" loading="lazy" decoding="async" className="h-12 w-auto" draggable={false} />
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-zinc-500">Sequenced AI income playbooks for people who want to build and ship—not collect more theory.</p>
            <div className="mt-6 flex flex-wrap gap-4 text-xs">
              <a href="https://www.instagram.com/stagvault/" target="_blank" rel="noreferrer" className="min-h-11 py-3 transition-colors hover:text-white" data-testid="footer-social-instagram">Instagram</a>
              <a href="https://www.tiktok.com/@stagvault" target="_blank" rel="noreferrer" className="min-h-11 py-3 transition-colors hover:text-white" data-testid="footer-social-tiktok">TikTok</a>
            </div>
          </div>

          <FooterColumn title="Product" links={PRODUCT_LINKS} />
          <FooterColumn title="Resources" links={RESOURCE_LINKS} />
          <FooterColumn title="Trust" links={TRUST_LINKS} />

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-300">Support</div>
            <p className="mt-4 text-sm leading-relaxed text-zinc-500">Questions before or after purchase are handled by the team behind the product.</p>
            <Link to="/contact" className="mt-3 inline-flex min-h-11 items-center gap-2 border border-zinc-700 px-4 text-xs font-black uppercase tracking-[0.16em] text-zinc-100 transition-colors hover:border-purple-400 hover:text-white" data-testid="footer-contact-button">Contact Stag Vault</Link>
          </div>
        </div>

        <div className="mt-12 grid gap-5 border-t border-zinc-900 pt-6 text-xs leading-relaxed text-zinc-600 md:grid-cols-12" data-testid="footer-legal-entity">
          <div className="md:col-span-8">
            <p><span className="font-semibold text-zinc-400">Homeguard Developments Ltd</span> · Registered in England and Wales · 3rd Floor, 86–90 Paul Street, London, England, EC2A 4NE</p>
            <p className="mt-2">© {year} Homeguard Developments Ltd. Stag Vault is a trading name of Homeguard Developments Ltd.</p>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 md:col-span-4 md:justify-end">
            <Link to="/terms" className="transition-colors hover:text-zinc-300" data-testid="footer-link-terms">Terms</Link>
            <Link to="/privacy" className="transition-colors hover:text-zinc-300" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/refund-policy" className="transition-colors hover:text-zinc-300" data-testid="footer-link-refund">Refund policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

const FooterColumn = ({ title, links }) => (
  <div className="lg:col-span-2">
    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-300">{title}</div>
    <ul className="mt-4 space-y-1">
      {links.map(([label, to, testId]) => <li key={to}><Link to={to} className="inline-flex min-h-10 items-center text-sm transition-colors hover:text-purple-300" data-testid={testId}>{label}</Link></li>)}
    </ul>
  </div>
);